import {dom} from "@polymer/polymer/lib/legacy/polymer.dom";

import {isSupported,getMessaging} from "firebase/messaging";

export class TTUtil {

    static withMessaging(callback) {
        isSupported().then(support => {
            if (support) {
                let messaging = getMessaging();
                callback(messaging)
            } else {
                console.log("Messaging not supported");
            }
        });
    }

    static withAnalytics(callback) {
        if (window.ga) {
            callback();
        }
    }

    static onGameChanges(newValue, oldValue, onInitial, onIncrementalUpdate) {

        // initial
        if (newValue && !oldValue) {
            // console.log("[Game] INITIAL");
            onInitial(newValue);
            return;
        }

        // update
        if (newValue && oldValue) {

            if (newValue.id === oldValue.id) {
                // console.log("[Game] INCREMENTAL UPDATE");
                onIncrementalUpdate(newValue);
                return;
            }

        }

        console.log("[Game] UNHANDELD CHANGE STATE", newValue, oldValue);

        // destruction
    }

    static applyOptionalQueryParam(ajaxElement, queryParamName, queryParamValue) {

        if (queryParamValue && queryParamValue !== "") {
            ajaxElement.params[queryParamName] = queryParamValue;
        } else {
            delete ajaxElement.params[queryParamName];
        }

    }

    static removeDialogNested(dialog) {
        const app = this.getApp(dialog);
        dom(app.shadowRoot.getElementById("dialogContainer")).removeChild(dialog);
    }

    static removeDialog(dialog) {
        this.removeDialogNested(dialog);
        document.body.classList.remove("dialogOpen");
    }

    static getApp(self) {
        return self.ownerDocument.querySelector("tt-app");
    }

    static showDialog(self, dialog) {
        const app = this.getApp(self);
        dom(app.shadowRoot.getElementById("dialogContainer")).appendChild(dialog);

        // TODO remove once all dialogs are migrated
        if (dialog.open)
            dialog.open();

        document.body.classList.add("dialogOpen");
    }

    static async sha1(obj) {

        let json = JSON.stringify(obj);
        let hash = await window.crypto.subtle.digest({name: "SHA-1"}, new TextEncoder().encode(json));
        let shaValue = this._hex(hash);

        return shaValue
    }

    static _hex(buffer) {
        var hexCodes = [];
        var view = new DataView(buffer);
        for (var i = 0; i < view.byteLength; i += 4) {
            // Using getUint32 reduces the number of iterations needed (we process 4 bytes each time)
            var value = view.getUint32(i)
            // toString(16) will give the hex representation of the number without padding
            var stringValue = value.toString(16)
            // We use concatenation and slice for padding
            var padding = '00000000'
            var paddedValue = (padding + stringValue).slice(-padding.length)
            hexCodes.push(paddedValue);
        }
        // Join all the hex strings into one

        return hexCodes.join("").toUpperCase();
    }

    static isSameGame(gameA, gameB){
        return gameA?.id === gameB?.id && gameA?.group === gameB?.group
    }
}
